import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/** @extends {Component<{toast:HTMLElement,message:HTMLElement}>} */
class VVCartFeedback extends Component {
  requiredRefs = ['toast', 'message'];
  #timer;
  #controller;
  #animations = new Set();
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate, {signal:this.#controller.signal});

  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    clearTimeout(this.#timer);
    this.#animations.forEach(animation => animation.cancel());
    this.#animations.clear();
  }
  #onCartUpdate = async event => {
    try {
      const result = await event.promise;
      if (!this.isConnected || !result || result.detail?.didError) return;
      const count = result.cart?.totalQuantity;
      if (Number.isFinite(count)) {
        document.querySelectorAll('[data-vv-desktop-cart-count]').forEach(badge => {
          const changed = Number(badge.textContent) !== count;
          badge.textContent = String(count);
          badge.hidden = count === 0;
          badge.closest('a')?.setAttribute('aria-label', `${Theme.translations.cart_count}: ${count}`);
          if (changed) this.#pulse(badge.closest('a'));
        });
      }
      if (event.action !== 'add') return;
      const normalizeId = value => String(value).split('/').pop();
      const requested = event.lines?.map(line => normalizeId(line.merchandiseId)) || [];
      const items = result.detail?.items;
      if (!Array.isArray(items) || !requested.length || !requested.every(id => items.some(item => normalizeId(item.variant_id || item.id) === id && item.quantity > 0))) {
        this.#showError();
        return;
      }
      this.refs.toast.classList.remove('is-error');
      const check = this.refs.toast.querySelector('.vv-cart-toast__check');
      if (check) check.textContent = '✓';
      const source = event.target instanceof Element ? event.target : null;
      this.#pulse(source?.querySelector('add-to-cart-component button'));
      clearTimeout(this.#timer);
      this.refs.message.textContent = this.dataset.message;
      this.refs.toast.classList.add('is-visible');
      this.#timer = setTimeout(() => this.refs.toast.classList.remove('is-visible'), 4000);
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.warn('[vv-cart-feedback] Cart update failed', error);
        if (event.action === 'add' && this.isConnected) this.#showError();
      }
    }
  };
  #showError = () => {
    clearTimeout(this.#timer);
    this.refs.message.textContent = this.dataset.errorMessage;
    const check = this.refs.toast.querySelector('.vv-cart-toast__check');
    if (check) check.textContent = '!';
    this.refs.toast.classList.add('is-error', 'is-visible');
    this.#timer = setTimeout(() => this.refs.toast.classList.remove('is-visible'), 6500);
  };
  #pulse = element => {
    if (!element || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const animation = element.animate([{transform:'scale(1)',opacity:1},{transform:'scale(1.16)',opacity:.55},{transform:'scale(1)',opacity:1}],{duration:650,easing:'ease'});
    this.#animations.add(animation);
    animation.finished.finally(() => this.#animations.delete(animation)).catch(() => {});
  };
}
if (!customElements.get('vv-cart-feedback')) customElements.define('vv-cart-feedback', VVCartFeedback);
